<app-modal title="Change History" [showCancel]="false" okText="Close">
	<sl-filters [config]="filterConfig" [fields]="filterFields" [options]="filterOptions" [filters]="filters" (filtersUpdated)="applyFilter($event)">
	</sl-filters>
	<sl-table #changeHistoryTable [config]="config" [filters]="filters" [data]="data"></sl-table>
</app-modal>
